import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Session from 'flarum/common/Session';
import SuggestPasskeyModal from '../components/SuggestPasskeyModal';
import { isSupported } from '../lib/webauthn';
const POST_LOGIN_FLAG = 'datlechin-passkey.post-login';
const DISMISSED_FLAG = 'datlechin-passkey.suggest-dismissed';
const DISMISS_DURATION_MS = 30 * 24 * 60 * 60 * 1000;

/** Must run at module top level so it patches Session.login before LogInModal calls it. */
export function patchSessionForConditionalCreate() {
  override(Session.prototype, 'login', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return original.apply(this, args).then(result => {
      try {
        sessionStorage.setItem(POST_LOGIN_FLAG, '1');
      } catch (_unused) {}
      return result;
    });
  });
}
export function checkConditionalCreate() {
  if (!isSupported()) return;
  const pending = takeFlag(POST_LOGIN_FLAG);
  if (!pending) return;
  if (isRecentlyDismissed()) return;
  setTimeout(surface, 0);
}
async function surface() {
  // Folds the user check and the count check into a single request: a guest
  // gets 401 and we silently abort, an authenticated user gets only their
  // own passkeys (the API resource is scoped by actor).
  let existing;
  try {
    existing = await app.store.find('passkeys');
  } catch (_unused2) {
    return;
  }
  if (existing.length > 0) return;
  app.modal.show(SuggestPasskeyModal, {
    onDismiss: rememberDismissal
  });
}
function takeFlag(key) {
  try {
    const value = sessionStorage.getItem(key);
    if (value !== null) sessionStorage.removeItem(key);
    return value;
  } catch (_unused3) {
    return null;
  }
}
function rememberDismissal() {
  try {
    localStorage.setItem(DISMISSED_FLAG, String(Date.now()));
  } catch (_unused4) {}
}
function isRecentlyDismissed() {
  try {
    var _localStorage$getItem;
    const stamp = Number((_localStorage$getItem = localStorage.getItem(DISMISSED_FLAG)) != null ? _localStorage$getItem : '0');
    return Number.isFinite(stamp) && Date.now() - stamp < DISMISS_DURATION_MS;
  } catch (_unused5) {
    return true;
  }
}
flarum.reg.add('datlechin-passkey', 'forum/extenders/conditionalCreateBootstrap', { patchSessionForConditionalCreate: patchSessionForConditionalCreate,checkConditionalCreate: checkConditionalCreate, });